import React from 'react'
import { useFooterStore } from '@/stores/footerStore'
import Button from '@/components/Button'
import { useTranslation } from 'react-i18next'
import { useThemeStore } from '@/stores/themeStore'

const Footer = (): React.ReactElement | null => {
  const { t } = useTranslation()
  const footerConfig = useFooterStore((s) => s.footerConfig)
  const { step, totalSteps, button, showLogo } = footerConfig
  const effective = useThemeStore((s) => s.effective)

  const isVisible = step || button || showLogo
  if (!isVisible) return null

  return (
    <footer className="fixed bottom-0 left-0 right-0 h-[60px] bg-card text-text flex justify-between items-center px-4 text-[0.9rem] z-[99] border-t border-beige-shade">
      <div className="w-full max-w-[860px] mx-auto flex items-center justify-between">
        <div className="flex-1 flex items-center justify-start">
          {step && totalSteps && (
            <span>
              {t('step')} {step} {t('of')} {totalSteps}
            </span>
          )}
        </div>

        <div className="flex-none flex items-center justify-center">
          {button && (
            <Button
              type="submit"
              onClick={button.onClick}
              variant="primary"
              size="medium"
              disabled={button.disabled}
              data-testid="footer-next-button"
            >
              {button.label}
            </Button>
          )}
        </div>

        <div className="flex-1 flex items-center justify-end">
          {showLogo && (
            <img
              src={effective === 'dark'
                ? '/beeldmerk-soft-beige.svg'
                : '/beeldmerk-moss-green.svg'
              }
              alt="logo"
              className="h-5 opacity-60"
            />
          )}
        </div>
      </div>
    </footer>
  )
}

export default Footer
